import { isBD } from "./businessType.lib.js";
const VIRTUAL_WAREHOUSE_CATALOGS = {
  US: "847",
  CA: "894"
};
function selectByWarehouse(val, selectedWarehouse, opts) {
  const { fallbackToVirtualWarehouse = true, fallbackToFirstItem = false } = opts || {};
  if (Array.isArray(val)) {
    if (selectedWarehouse == null ? void 0 : selectedWarehouse.catalog) {
      const found = val.find(
        (v) => v.warehouseNumber === selectedWarehouse.catalog
      );
      if (found) return found;
      const virtualWarehouseCatalog = getVirtualWarehouseCatalog(
        opts == null ? void 0 : opts.locale
      );
      if (fallbackToVirtualWarehouse && (selectedWarehouse == null ? void 0 : selectedWarehouse.catalog) !== virtualWarehouseCatalog) {
        const virtualFound = val.find(
          (v) => v.warehouseNumber === virtualWarehouseCatalog
        );
        if (virtualFound) return virtualFound;
      }
    }
    return fallbackToFirstItem ? val[0] : void 0;
  }
  return val;
}
function getVirtualWarehouseCatalog(locale) {
  const country = (locale == null ? void 0 : locale.toLowerCase().includes("us")) ? "US" : "CA";
  return VIRTUAL_WAREHOUSE_CATALOGS[country];
}
function getSelectedWarehouseCatalog(locale, cookieContext, opts) {
  const { warehouse, bdWarehouseNumber } = cookieContext || {};
  const { isOnlinePrice, isWarehousePrice } = opts || {};
  const { nearestWarehouse } = warehouse || {};
  const virtualWarehouse = getVirtualWarehouseCatalog(locale);
  let selectedWarehouse = void 0;
  if (isOnlinePrice) {
    selectedWarehouse = isBD() ? bdWarehouseNumber == null ? void 0 : bdWarehouseNumber.value : virtualWarehouse;
  } else if (isWarehousePrice) {
    selectedWarehouse = nearestWarehouse;
  }
  return typeof selectedWarehouse === "string" ? { catalog: selectedWarehouse } : selectedWarehouse;
}
export {
  VIRTUAL_WAREHOUSE_CATALOGS,
  getSelectedWarehouseCatalog,
  getVirtualWarehouseCatalog,
  selectByWarehouse
};
